import React, { ReactNode } from 'react';
import { RESTRICTION_ACCESS } from 'src/constants/integrations';
import { ICustomTooltipProps } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import IntegrationTooltip from 'src/view/components/IntegrationTooltip/IntegrationTooltip';

interface IProps {
  setting: RESTRICTION_ACCESS | undefined;
  wrapperClassName?: string;
  tooltipOptions?: Partial<ICustomTooltipProps>;
  withTooltip?: boolean;
  children?: ReactNode;
}

/**
 * Handler for elements affected by integrations
 *
 * @param setting Restriction access
 * @param wrapperClassName Content wrapper class name
 * @param tooltipOptions Integration tooltip props
 * @param withTooltip Whether disabled element should be handled with tooltip
 * @param children Handling elements
 */
const IntegrationManager = ({ setting, wrapperClassName, tooltipOptions, withTooltip, children }: IProps) => {
  const handleDisabledContent = () => {
    const content = withTooltip ? (
      <IntegrationTooltip tooltipOptions={tooltipOptions} isVisible>
        {children}
      </IntegrationTooltip>
    ) : (
      <>{children}</>
    );

    return renderContent(content);
  };

  const renderContent = (content: React.ReactNode) => {
    return wrapperClassName ? <div className={wrapperClassName}>{content}</div> : <>{content}</>;
  };

  switch (setting) {
    case RESTRICTION_ACCESS.HIDDEN:
      return null;
    case RESTRICTION_ACCESS.DISABLED:
      return handleDisabledContent();
    default:
      return renderContent(children);
  }
};

export default IntegrationManager;
